module.exports = __webpack_public_path__ + "img/fraud-8.be774c4d.jpg";